import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { TrafficAreaItem } from './components/TrafficAreaItem'

type Props = RenderItemProps<'trafficAreas'>

export function Item(props: Props) {
  return props.type === 'item' ? <TrafficAreaItem {...props} /> : null
}
